import React from "react";
import {
  Grid,
  Box,
  FormControl,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({ label, value, onChange, onClear }) => {
  return (
    <Box display="flex" justifyContent="end" alignItems="center">
      <Box>
        <FormControl fullWidth>
          <TextField
            size="small"
            label={
              <Typography component="p" variant="body2" noWrap>
                {label}
              </Typography>
            }
            value={value || ""}
            onChange={onChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {value !== "" && (
                    <IconButton
                      id="clear-search"
                      aria-label="Clear Search"
                      onClick={onClear}
                      edge="end"
                    >
                      <ClearIcon color="secondary" />
                    </IconButton>
                  )}
                  <IconButton aria-label="Search" edge="end">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
      </Box>
    </Box>
  );
};

export default SearchBar;
